<template>
  <div class="login">
    <div class="blur"></div>

    <div class="container">
      <h3 class="title">励志社工系统管理后台</h3>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="login_form" @keyup.enter.native="submitForm('ruleForm')">
        <el-form-item prop="account">
          <el-input v-model="ruleForm.account" placeholder="请输入账号">
            <img slot="prefix" src="../assets/img/login/user.png" />
          </el-input>
        </el-form-item>
        <el-form-item prop="password" class="pwd">
          <el-input v-model="ruleForm.password" show-password placeholder="请输入密码">
            <img slot="prefix" src="../assets/img/login/pass.png" />
          </el-input>
        </el-form-item>
        <el-form-item prop="" class="radio">
          <el-radio-group v-model="ruleForm.radio">
            <el-radio :label="1" size="medium">管理员</el-radio>
            <el-radio :label="2" size="medium">主讲专家</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="btnLoading" @click="submitForm('ruleForm')">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      btnLoading: false,
      ruleForm: {
        account: "",
        password: "",
        radio: 1,
      },
      rules: {
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        radio: [{ required: true, message: "请选择身份", trigger: "change" }],
      },
    }
  },
  created() {
    this.$store.dispatch("logout")
  },
  mounted() {
    localStorage.clear()
  },
  methods: {
    goToUrl(value) {
      if (value == 1) {
        this.$router.push({ path: "/register" })
      } else {
        this.$router.push({ path: "/forgotPassword" })
      }
    },
    // 递归方法用于获取所有最深层子元素的menuPath
    getDeepestMenuPath(arr) {
      let paths = [] // 用于存储所有找到的menuPath
      // 递归函数
      function recurse(children, depth) {
        // 遍历当前层级的children
        for (let item of children) {
          // 如果当前item没有children，则认为它是叶子节点，记录其menuPath
          if (!item.children || item.children.length === 0) {
            paths.push(item.menuPath)
          } else {
            // 如果有children，则递归进入下一层
            recurse(item.children, depth + 1)
          }
        }
      }
      // 开始递归
      recurse(arr, 0)
      return paths // 返回所有最深层menuPath组成的数组
    },
    // 登录
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.btnLoading = true
          this.$axios
            .post(this.$api.login, {
              userAccount: this.ruleForm.account,
              userPassword: this.ruleForm.password,
              // bizSys: this.$bizSys, // 业务系统(原)
              bizSys: this.ruleForm.radio, // 业务系统(新) (1:管理员 2:教师)
            })
            .then(res => {
              const menus = res.result.sysMenuVoList
              let paths = this.getDeepestMenuPath(menus)
              this.$store.commit("setToken", res.result.token)
              this.$store.commit("setMenuList", menus)
              this.$store.commit("setUserInfo", res.result.sysUser)
              this.$message.success("登录成功")
              setTimeout(() => {
                // 在登录跳转方法中添加强制清除css动画效果，否则在登录成功后，会出现白屏的现象
                this.$router.push("/target-path").catch(() => {})
                document.querySelectorAll(".login").forEach(el => {
                  el.style.animation = "none"
                  el.style.background = "transparent"
                })
                if (menus.length > 0) {
                  let path = paths[0]
                  this.$router.replace({ path })
                } else {
                  this.$router.replace("/404")
                }
              }, 500)
              this.btnLoading = false
            })
            .catch(err => {
              this.btnLoading = false
              this.$message.error(err.desc)
            })
        } else {
          this.btnLoading = false
          this.$message.error("登录失败")
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  .blur {
    // position: absolute;
    // top: 0;
    // left: 0;
    // right: 0;
    // bottom: 0;
    // background: url(../assets/img/login/login.png) no-repeat;
    // background-size: cover;
    // background-position: 100% 30%;
    // filter: blur(2px);
  }

  .container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 22px;
    border-radius: 6px;
    background-color: #fff;
    .title {
      color: #1a1a1a;
      font-size: 26px;
      text-align: center;
      font-weight: 500;
      margin-bottom: 60px;
    }

    .login_form {
      width: 400px;

      ::v-deep .el-input__inner {
        width: 100%;
        height: 50px;
        font-size: 16px;
        padding-left: 46px;
        border: 1px solid #dcdfe6;
        border-radius: 10px;
        background-color: #fff;

        &:hover {
          border-color: #c0c4cc;
        }

        &:focus {
          border-color: $themes;
        }
      }

      ::v-deep .el-input__prefix {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 46px;

        img {
          width: 16px;
          height: 18px;
        }
      }

      .el-form-item:last-child {
        margin-bottom: 0;
      }

      .pwd {
        margin-bottom: 12px;
      }

      .radio {
        text-align: center;
      }

      .el-button {
        width: 100%;
        height: 50px;
        font-size: 16px;
        border-radius: 10px;
      }
    }
  }
}
.login {
  /* 最终版：深度降亮 + 奶油色点缀 */
  background: linear-gradient(135deg, hsl(358, 66%, 10%) 0%, /* 深黑红色（累计降亮50%） */ hsl(357, 66%, 18%) 45%, /* 暗酒红色（累计降亮50%） */ hsl(24, 85%, 85%) 90% /* 替换为奶油色 #FBD2B7（RGB→HSL转换） */);
  background-size: 300% 300%;
  animation: gradientFlow 10s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  position: relative;
}

/* 极暗光效层（与深背景协调） */
.login::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 70% 20%, rgba(150, 50, 25, 0.4) 0%, /* 累计降亮50%的深红光 */ transparent 70% /* 扩大透明区域 */);
  pointer-events: none;
}

@keyframes gradientFlow {
  0% {
    background-position: 10% 30%;
  }
  50% {
    background-position: 90% 70%;
  }
  100% {
    background-position: 10% 30%;
  }
}
</style>
